<template>
	<div>
		<a-page-header style="background: #fff;" title="充值管理" :breadcrumb="{props:{routes:[{breadcrumbName:'首页'},{breadcrumbName:'充值管理'}]}}">
			<template slot="extra">
				<a-button type="primary" @click="addModal = true">
					添加充值方案
				</a-button>
			</template>
		</a-page-header>

		<!-- 列表 -->
		<div class="mainBox">
			<div class="contentBox">
				<a-table :columns="columns" :dataSource="list" rowKey="id" :pagination="pagination" :loading="loading" @change="handleTableChange">
					<span slot="rechargeMoney" slot-scope="rechargeMoney">
						{{rechargeMoney}} 元
					</span>
					<span slot="rechargeSend" slot-scope="rechargeSend">
						{{rechargeSend}} 元
					</span>
					<span slot="rechargeStatus" slot-scope="rechargeStatus">
						<a-tag color="green" v-if="rechargeStatus == 1">开启</a-tag>
						<a-tag color="red" v-if="rechargeStatus == 0">关闭</a-tag>
					</span>
					<span slot="action" slot-scope="text, record">
						<a @click="toDetail(record.id)">详情</a>
						<a-divider type="vertical" />
						<a-popconfirm title="请确认是否删除？" okText="是" cancelText="否" @confirm="del(record.id)">
							<a href="javascript:;" style="color: #ff4d4f;">删除</a>
						</a-popconfirm>
					</span>
				</a-table>
			</div>
		</div>

		<!-- 添加充值方案弹出 -->
		<a-modal title="添加充值方案" v-model="addModal" @ok="addSubmit" cancelText="取消" okText="添加" width="50%">
			<a-form-model ref="addForm" :model="addForm" :rules="addRules" :label-col="{ span: 8 }" :wrapper-col="{ span: 10 }">
				<a-form-model-item label="方案名称" prop="rechargeName">
					<a-input v-model="addForm.rechargeName" />
				</a-form-model-item>
				<a-form-model-item label="充值金额" prop="rechargeMoney">
					<a-input v-model="addForm.rechargeMoney" />
				</a-form-model-item>
				<a-form-model-item label="赠送" prop="rechargeSend">
					<a-input v-model="addForm.rechargeSend"></a-input>
				</a-form-model-item>
				<a-form-model-item label="开启状态" prop='rechargeStatus'>
					<a-switch checked-children="开启" un-checked-children="关闭" v-model="addForm.rechargeStatus" default-checked />
				</a-form-model-item>
			</a-form-model>
		</a-modal>

		<!-- 编辑充值方案弹出 -->
		<a-modal title="编辑充值方案" v-model="editModal" @ok="editSubmit" cancelText="取消" okText="修改" width="50%">
			<a-form-model ref="editForm" :model="editForm" :rules="addRules" :label-col="{ span: 8 }" :wrapper-col="{ span: 10 }">
				<a-form-model-item label="方案名称" prop="rechargeName">
					<a-input v-model="editForm.rechargeName" />
				</a-form-model-item>
				<a-form-model-item label="充值金额" prop="rechargeMoney">
					<a-input v-model="editForm.rechargeMoney" />
				</a-form-model-item>
				<a-form-model-item label="赠送" prop="rechargeSend">
					<a-input v-model="editForm.rechargeSend"></a-input>
				</a-form-model-item>
				<a-form-model-item label="开启状态" prop='rechargeStatus'>
					<a-switch checked-children="开启" un-checked-children="关闭" v-model="editForm.rechargeStatus" default-checked />
				</a-form-model-item>
			</a-form-model>
		</a-modal>
	</div>
</template>

<script>
	const columns = [{
			title: 'ID',
			dataIndex: 'id',
		},
		{
			title: '方案名称',
			dataIndex: 'rechargeName',
			scopedSlots: {
				customRender: 'rechargeName'
			},
		},
		{
			title: '充值金额',
			dataIndex: 'rechargeMoney',
			scopedSlots: {
				customRender: 'rechargeMoney'
			},
		},
		{
			title: '赠送',
			dataIndex: 'rechargeSend',
			scopedSlots: {
				customRender: 'rechargeSend'
			},
		},
		{
			title: '开启状态',
			dataIndex: 'rechargeStatus',
			scopedSlots: {
				customRender: 'rechargeStatus'
			},
		},
		{
			title: '添加时间',
			dataIndex: 'addTime',
		},
		{
			title: '操作',
			dataIndex: 'action',
			scopedSlots: {
				customRender: 'action'
			},
		},
	];

	export default {
		data() {
			return {
				columns,
				list: [],
				pagination: {
					pageSize: 20,
					total: 0,
					current: 1
				},
				addForm: {
					rechargeStatus: true
				},
				editModal: false,
				editForm: {},
				addModal: false,
				loading: false,
				addRules: {
					rechargeName: [{
						required: true,
						message: '请填写方案名称',
						trigger: 'blur'
					}],
					rechargeMoney: [{
						required: true,
						message: '请填写充值金额',
						trigger: 'blur'
					}],
					rechargeSend: [{
						required: true,
						message: '请填写赠送金额',
						trigger: 'blur'
					}],
				},
			};
		},

		mounted() {
			this.getList()
		},

		methods: {
			toDetail(id) {
				this.rechargeId = id
				this.$http.post('/admin/index.php/admin/Acit/rechargeAcitInfo', {
					id: id
				}).then((res) => {
					if (res.data.code == 1) {
						this.editForm = res.data.data
						this.editModal = true
					}
				})
			},

			editSubmit() {
				this.$refs.editForm.validate(valid => {
					if (valid) {
						this.$http.post('/admin/index.php/admin/Acit/rechargeAcitSave', {
							id: this.rechargeId,
							rechargeName: this.editForm.rechargeName,
							rechargeMoney: this.editForm.rechargeMoney,
							rechargeSend: this.editForm.rechargeSend,
							rechargeStatus: this.editForm.rechargeStatus,
						}).then(res => {
							if (res.data.code == 1) {
								this.$message.success('修改成功！');
								this.editModal = false
								this.getList()
							} else {
								this.$message.error(res.data.msg);
							}
						})
					}
				});
			},

			addSubmit() {
				this.$refs.addForm.validate(valid => {
					if (valid) {
						this.$http.post('/admin/index.php/admin/Acit/rechargeAcitSave', {
							rechargeName: this.addForm.rechargeName,
							rechargeMoney: this.addForm.rechargeMoney,
							rechargeSend: this.addForm.rechargeSend,
							rechargeStatus: this.addForm.rechargeStatus,
						}).then(res => {
							if (res.data.code == 1) {
								this.$message.success('添加成功！');
								this.addModal = false
								this.getList()
							} else {
								this.$message.error(res.data.msg);
							}
						})
					}
				});
			},

			del(id) {
				this.$http.post('/admin/index.php/admin/Shop/rechargeAcitDel', {
					id: id
				}).then((res) => {
					if (res.data.code == 1) {
						this.$message.success(res.data.msg);
						this.getList();
					} else {
						this.$message.error(res.data.msg);
					}
				})
			},

			handleTableChange(pagination, filters, sorter) {
				this.list = []
				this.pagination.current = pagination.current
				this.getList()
			},

			getList() {
				this.loading = true
				var data = {
					page: this.pagination.current,
					num: this.pagination.pageSize,
				}
				this.$http.post('/admin/index.php/admin/Acit/rechargeAcit', data).then(res => {
					this.loading = false
					if (res.data.code == 1) {
						this.list = res.data.data
						this.pagination.total = res.data.count
					} else {
						this.$message.error(res.data.msg);
					}
				})
			},
		}
	}
</script>

<style scoped="">
	.ant-upload-select-picture-card i {
		font-size: 32px;
		color: #999;
	}

	.ant-upload-select-picture-card .ant-upload-text {
		margin-top: 8px;
		color: #666;
	}
</style>
